import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRouter from './routes';
import * as serviceWorker from './serviceWorker';

require("./css/variables.css");

const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(
        <AppRouter />
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
